module.exports = "<div class=\"panes\" [@slide]=\"activePane\">\r\n  <div><ng-content select=\"[leftPane]\"></ng-content></div>\r\n  <div><ng-content select=\"[rightPane]\"></ng-content></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/slide-panel/slide-panel.component.html
// module id = ../../../../../src/app/shared/components/slide-panel/slide-panel.component.html
// module chunks = main